// src/pages/billing/order/ViewOrder.jsx
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/api";
import SuperAdminLayout from "../../../layouts/SuperAdminLayout";
import { PDFDocument, StandardFonts } from "pdf-lib";
import BillingLayout from "../../../layouts/BillingLayout";

const BillingViewOrder = () => {
  const billingUser = JSON.parse(localStorage.getItem("user"));
  const superAdminId = billingUser?.superAdminId;
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (superAdminId) {
      api
        .get(`/api/orders/get-all/${superAdminId}`)
        .then((res) => setOrders(res.data))
        .catch(console.error);
    }
  }, [superAdminId]);

  const previewPDF = async (order) => {
    const tplBytes = await fetch("/order-template.pdf").then((r) =>
      r.arrayBuffer()
    );
    const pdfDoc = await PDFDocument.load(tplBytes);
    const page = pdfDoc.getPages()[0];
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const draw = (txt, opts) => {
      try {
        page.drawText(String(txt), opts);
      } catch {}
    };

    draw(order.challanNumber || "N/A", { x: 460, y: 670, size: 12, font });
    draw((order.date || "").slice(0, 10), { x: 450, y: 700, size: 12, font });
    draw(order.customer || "N/A", { x: 160, y: 675, size: 12, font });

    order.items.slice(0, 15).forEach((it, i) => {
      const y = 592 - 20 * (i + 1);
      draw(it.product || "N/A", { x: 112, y, size: 10, font });
      draw(it.quantity || 0, { x: 335, y, size: 10, font });
      draw(it.price?.toFixed(2) || "0.00", { x: 418, y, size: 10, font });
      draw((it.quantity * it.price || 0).toFixed(2), {
        x: 480,
        y,
        size: 10,
        font,
      });
    });

    draw(`Total: ₹${order.total?.toFixed(2) || "0.00"}`, {
      x: 400,
      y: 140,
      size: 12,
      font,
    });

    const bytes = await pdfDoc.save();
    const blob = new Blob([bytes], { type: "application/pdf" });
    setPdfUrl(URL.createObjectURL(blob));
  };

  return (
    <BillingLayout>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h5">Orders</Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/billing/order/create")}
          >
            + New Order
          </Button>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Order No</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Total</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((o) => (
                <TableRow key={o._id}>
                  <TableCell>{o.challanNumber}</TableCell>
                  <TableCell>{o.customer}</TableCell>
                  <TableCell>
                    {new Date(o.date).toISOString().slice(0, 10)}
                  </TableCell>
                  <TableCell>₹{o.total.toFixed(2)}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={() => previewPDF(o)}>
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          open={!!pdfUrl}
          onClose={() => setPdfUrl(null)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>Order Preview</DialogTitle>
          <DialogContent>
            {pdfUrl && (
              <iframe
                src={pdfUrl}
                title="Order PDF"
                width="100%"
                height="600px"
                style={{ border: "none" }}
              />
            )}
          </DialogContent>
        </Dialog>
      </Container>
    </BillingLayout>
  );
};

export default BillingViewOrder;
